import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LandingComponent } from '@app/modules/landing/landing.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MainComponent } from './modules/main/main.component';
import { AccountStatusComponent } from './modules/account-status/account-status.component';
import { AccountHistoryComponent } from './modules/account-history/account-history.component';
import { EdocumentsComponent } from './modules/edocuments/edocuments.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { NoCacheHeadersInterceptor } from './interceptors/no-cache-headers.interceptor';
import { JwtInterceptor } from './interceptors/jwt-interceptor';
import { SiteAgreementComponent } from './modules/site-agreement/site-agreement.component';
import { MaterialModule } from './material/material.module';
import { TransactionTypePipe } from './pipes/transaction-type.pipe';
import { CommodityDescriptionPipe } from './pipes/commodity-description.pipe';
import { StoplimitTypePipe } from './pipes/stoplimit-type.pipe';
import { UppercaseFirstLetterPipe } from './pipes/uppercase-first-letter.pipe';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBell as farBell,
         faFilePdf as farFilePdf,      
         faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faBell as fasBell,
         faFilePdf as fasFilePdf,
         faCog,
         faChartLine,
         faPlus,
         faEquals,
         faDownload,
         faFileInvoice,
         faChartPie,
         faInbox,
         faMapMarkerAlt,
         faCircle as fasCircle,
         faLock as fasLock,
         faBars as fasBars,
         faComments as fasComments,
         faCheckCircle as fasCheckCircle,
         faChevronLeft as fasChevronLeft,
         faChevronRight as fasChevronRight,
         faChevronUp as fasChevronUp,
         faLowVision as fasLowVision,
         faEye as fasEye,
         faSignInAlt as fasSignInAlt,
         faSignOutAlt as fasSignOutAlt,
         faEyeSlash as fasEyeSlash,
         faKey as fasKey,
         faIdCard as fasIdCard,
         faUserFriends as fasUserFriends,              
         faHeadset as fasHeadset,
         faUserCog as fasUserCog,   
         faTools as fasTools, 
         faFileInvoiceDollar as fasFileInvoiceDollar,
         faQuestionCircle as fasQuestionCircle,
         faExclamationCircle as fasExclamationCircle,
         faSync as fasSync,
         faCloudDownloadAlt as fasCloudDownloadAlt,
         faFileSignature as fasFileSignature,
         faIdBadge as fasIdBadge
        } from '@fortawesome/free-solid-svg-icons';
import { faFacebook as fabFacebook, faLinkedin as fabLinkedin, faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons';        
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BnNgIdleService } from 'bn-ng-idle';
import { CountdownModule } from 'ngx-countdown';
import { DepositoryConfirmationComponent } from './modules/depository-confirmation/depository-confirmation.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { LoginComponent } from './modules/login/login.component';
import { SummaryComponent } from './modules/summary/summary.component';
import { CashDescriptionPipe } from './pipes/cash-description.pipe';
import { MinusSignToParensPipe } from './pipes/minus-sign-to-parens.pipe';
import { CustomerGainLossPipe } from './pipes/customer-gain-loss.pipe';
import { DatePipe } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { EsignComponent } from './modules/esign/esign.component';
import { ProfileComponent } from './modules/profile/profile.component';


@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    MainComponent,
    AccountStatusComponent,
    AccountHistoryComponent,
    EdocumentsComponent,
    ClickOutsideDirective,
    SiteAgreementComponent,
    TransactionTypePipe,
    CommodityDescriptionPipe,
    StoplimitTypePipe,
    UppercaseFirstLetterPipe,
    DepositoryConfirmationComponent,
    AutoFocusDirective,
    LoginComponent,
    SummaryComponent,
    CashDescriptionPipe,
    MinusSignToParensPipe,
    CustomerGainLossPipe,
    EsignComponent,
    ProfileComponent,

        
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HttpClientModule,
    FontAwesomeModule,
    NgxExtendedPdfViewerModule,   
    NgApexchartsModule,
    CountdownModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NoCacheHeadersInterceptor, multi: true},
    BnNgIdleService,
    DatePipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {   

  constructor(library: FaIconLibrary) {
    library.addIcons(farBell, fasBell, fasFilePdf, faCog, faChartLine, farFilePdf, faPlus, faEquals,
       faDownload, faTimesCircle, faFileInvoice, faChartPie, faInbox, faMapMarkerAlt,
       fasCircle, fasLock, fasBars, fasComments, fasCheckCircle, fasChevronLeft, fasChevronRight, fasChevronUp, fasLowVision,
       fasEye, fasSignInAlt, fasSignOutAlt, fasEyeSlash, fasKey, fasIdCard, fasUserFriends, fabFacebook, fabLinkedin,
       fabYoutube, fasHeadset, fasUserCog, fasTools, fasFileInvoiceDollar, fasQuestionCircle, fasExclamationCircle, fasSync,
       fasCloudDownloadAlt, fasFileSignature, fasIdBadge);
  }


 }
